import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}

function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}

export async function fetchSprints(ativo) {
  const base = getBase();
  if (!base) return [];
  try {
    const params = ativo !== undefined ? { ativo: ativo ? 1 : 0 } : {};
    const res = await axios.get(base + '/sprints', { headers: getAuthHeaders(), params, timeout: 10000 });
    const data = res?.data;
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.sprints)) return data.sprints;
    if (data && Array.isArray(data.data)) return data.data;
    return [];
  } catch (err) {
    if (err?.response?.status === 404 || err?.response?.data?.error) return [];
    console.error('Erro ao listar sprints:', err);
    return [];
  }
}

export async function fetchSprint(id) {
  const base = getBase();
  if (!base || !id) return null;
  try {
    const res = await axios.get(base + '/sprints/' + id, { headers: getAuthHeaders(), timeout: 10000 });
    return res?.data ?? null;
  } catch (err) {
    console.error('Erro ao carregar sprint:', err);
    return null;
  }
}

export async function createSprint(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sprints', body, { headers: getAuthHeaders() });
}

export async function updateSprint(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/sprints/' + id, body, { headers: getAuthHeaders() });
}

export async function ativarSprint(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sprints/' + id + '/ativar', {}, { headers: getAuthHeaders() });
}

export async function concluirSprint(id, justificativaConclusao) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sprints/' + id + '/concluir', { justificativa_conclusao: justificativaConclusao || null }, { headers: getAuthHeaders() });
}

export async function fetchSatNumsEmSprint() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/sprints/sat-nums-em-sprint', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data?.sat_nums) ? res.data.sat_nums : [];
  } catch (err) {
    console.error('Erro ao listar sat_nums em sprint:', err);
    return [];
  }
}

export async function fetchBurndownSprint(sprintId) {
  const base = getBase();
  if (!base || !sprintId) return [];
  try {
    const res = await axios.get(base + '/sprints/' + sprintId + '/burndown', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data?.pontos) ? res.data.pontos : [];
  } catch (err) {
    console.error('Erro ao carregar burn down da sprint:', err);
    return [];
  }
}

export async function fetchChamadosSprint(sprintId) {
  const base = getBase();
  if (!base || !sprintId) return [];
  try {
    const res = await axios.get(base + '/sprints/' + sprintId + '/chamados', { headers: getAuthHeaders(), timeout: 10000 });
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) {
    console.error('Erro ao listar chamados da sprint:', err);
    return [];
  }
}

export async function addChamadosSprint(sprintId, satNums, estimativaHoras, itens) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const body = itens && itens.length > 0
    ? { itens: itens.map((i) => ({
        sat_num: i.sat_num,
        estimativa_horas: i.estimativa_horas != null ? i.estimativa_horas : null,
        prioridade: ['alta', 'media', 'baixa'].includes(i.prioridade) ? i.prioridade : 'media',
        depende_de: Array.isArray(i.depende_de) ? i.depende_de : []
      })) }
    : { sat_nums: satNums, estimativa_horas: estimativaHoras || null };
  return axios.post(base + '/sprints/' + sprintId + '/chamados', body, { headers: getAuthHeaders() });
}

export async function removeChamadoSprint(sprintId, satNum) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/sprints/' + sprintId + '/chamados/' + satNum, { headers: getAuthHeaders() });
}

export async function moverChamadoSprint(sprintId, sprintChamadoId, payload) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.patch(base + '/sprints/' + sprintId + '/chamados/' + sprintChamadoId + '/mover', payload, { headers: getAuthHeaders() });
}

export async function iniciarSessaoSprint(sprintChamadoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sprints/chamados/' + sprintChamadoId + '/iniciar', {}, { headers: getAuthHeaders() });
}

export async function pausarSessaoSprint(sprintChamadoId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/sprints/chamados/' + sprintChamadoId + '/pausar', {}, { headers: getAuthHeaders() });
}

export async function updatePrioridadeItemSprint(sprintId, sprintChamadoId, prioridade) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  const val = ['alta', 'media', 'baixa'].includes(prioridade) ? prioridade : 'media';
  return axios.patch(base + '/sprints/' + sprintId + '/chamados/' + sprintChamadoId + '/prioridade', { prioridade: val }, { headers: getAuthHeaders() });
}
